<template>
	<div >
		<div class="zhenwen_neir" style="margin: 20px 1%; font-size: 16pt; line-height: 40px;">
			<div class="TRS_Editor">
				<p align="center" class="MsoNormal"
					style="text-align: center; margin: 0cm 0cm 12pt; line-height: 40px; font-size: 16pt;"><b
						style="mso-bidi-font-weight: normal"><span
							style="font-size: 16pt; font-family: 宋体; line-height: 40px;">国务院安委会办公室关于开展<span lang="EN-US"
								style="font-size: 16pt; line-height: 40px;">
								<o:p></o:p>
							</span></span></b></p>
				<p align="center" class="MsoNormal"
					style="text-align: center; margin: 0cm 0cm 12pt; line-height: 40px; font-size: 16pt;"><b
						style="mso-bidi-font-weight: normal"><span
							style="font-size: 16pt; font-family: 宋体; line-height: 40px;">建筑施工安全专项治理行动的通知</span></b></p>
				<p align="center" class="MsoNormal"
					style="text-align: center; margin: 0cm 0cm 12pt; line-height: 40px; font-size: 16pt;"><span
						style="font-size: 16pt; font-family: 宋体; line-height: 40px;"><span
							style="font-size: 16pt; font-family: 楷体_GB2312; line-height: 40px;">安委办〔<span
								lang="EN-US" style="font-size: 16pt; line-height: 40px;">2018</span>〕<span lang="EN-US"
								style="font-size: 16pt; line-height: 40px;">10</span>号</span></span><span lang="EN-US"
						style="font-size: 16pt; line-height: 40px;">
						<o:p></o:p>
					</span></p>
				<span
					style="font-size: 16pt; font-family: 宋体; mso-ascii-theme-font: minor-fareast; mso-fareast-font-family: 宋体; mso-fareast-theme-font: minor-fareast; mso-hansi-theme-font: minor-fareast">
					<p class="MsoNormal" style="margin: 0cm 0cm 12pt; line-height: 40px; font-size: 16pt;"><span
							style="font-size: 16pt; font-family: 宋体; line-height: 40px;">各省、自治区、直辖市及新疆生产建设兵团安全生产委员会，工业和信息化部、住房城乡建设部、交通运输部、水利部、国家能源局、国家铁路局、中国民用航空局，有关中央企业：</span><span
							lang="EN-US" style="font-size: 16pt; font-family: 宋体; line-height: 40px;">
							<o:p>&nbsp;</o:p>
						</span></p>
				</span><span
					style="font-size: 16pt; font-family: 宋体; mso-ascii-theme-font: minor-fareast; mso-fareast-font-family: 宋体; mso-fareast-theme-font: minor-fareast; mso-hansi-theme-font: minor-fareast">
					<p class="MsoNormal"
						style="margin: 0cm 0cm 12pt; line-height: 40px; text-indent: 32pt; font-size: 16pt;"><span
							lang="EN-US" style="font-size: 16pt; line-height: 40px;">2017</span><span
							style="font-size: 16pt; line-height: 40px;">年以来，全国安全生产形势持续好转，但建筑施工特别是隧道施工安全事故多发，给人民群众生命财产安全造成巨大损失，建筑施工安全形势十分严峻。为认真贯彻落实全国安全生产电视电话会议和《国务院安全生产委员会关于印发<span
								lang="EN-US" style="font-size: 16pt; line-height: 40px;">2018</span>年工作要点的通知》（安委〔<span
								lang="EN-US" style="font-size: 16pt; line-height: 40px;">2018</span>〕<span lang="EN-US"
								style="font-size: 16pt; line-height: 40px;">1</span>号）工作部署，切实做好建筑施工安全工作，有效防范和坚决遏制重特大事故，国务院安委会办公室定于<span
								lang="EN-US" style="font-size: 16pt; line-height: 40px;">2018</span>年<span lang="EN-US"
								style="font-size: 16pt; line-height: 40px;">4</span>月下旬至<span lang="EN-US"
								style="font-size: 16pt; line-height: 40px;">12</span>月底，在全国开展以隧道施工安全为重点的建筑施工安全专项治理行动。现就有关事项通知如下：</span>&nbsp;
					</p>
					<p class="MsoNormal"
						style="margin: 0cm 0cm 12pt; line-height: 40px; text-indent: 32pt; font-size: 16pt;"><span
							style="font-size: 16pt; font-family: 宋体; line-height: 40px;">一、工作目标<span lang="EN-US"
								style="font-size: 16pt; line-height: 40px;">
								<o:p></o:p>
							</span></span></p>
					<p class="MsoNormal"
						style="margin: 0cm 0cm 12pt; line-height: 40px; text-indent: 32pt; font-size: 16pt;"><span
							style="font-size: 16pt; font-family: 宋体; line-height: 40px;">坚持以习近平新时代中国特色社会主义思想为指导，深入贯彻落实党的十九大精神，全面落实党中央、国务院关于安全生产的决策部署，牢固树立安全发展理念，大力弘扬生命至上、安全第一的思想，以防范和遏制建筑施工重特大事故为重点，进一步加强安全监管执法力度，压实企业主体责任，规范施工现场安全管理，强化施工企业复杂地质条件下隧道施工安全意识和应对能力，努力实现<span
								lang="EN-US"
								style="font-size: 16pt; line-height: 40px;">2018</span>年建筑施工较大事故同比下降、重特大事故得到有效遏制的目标要求，坚决维护人民群众生命财产安全和社会稳定。<span
								lang="EN-US" style="font-size: 16pt; line-height: 40px;">
								<o:p></o:p>
							</span></span></p>
					<p class="MsoNormal"
						style="margin: 0cm 0cm 12pt; line-height: 40px; text-indent: 32pt; font-size: 16pt;"><span
							style="font-size: 16pt; font-family: 宋体; line-height: 40px;">二、治理范围和内容<span lang="EN-US"
								style="font-size: 16pt; line-height: 40px;">
								<o:p></o:p>
							</span></span></p>
					<p class="MsoNormal"
						style="margin: 0cm 0cm 12pt; line-height: 40px; text-indent: 32pt; font-size: 16pt;"><span
							style="font-size: 16pt; font-family: 宋体; line-height: 40px;">（一）专项治理范围。<span lang="EN-US"
								style="font-size: 16pt; line-height: 40px;">
								<o:p></o:p>
							</span></span></p>
					<p class="MsoNormal"
						style="margin: 0cm 0cm 12pt; line-height: 40px; text-indent: 32pt; font-size: 16pt;"><span
							style="font-size: 16pt; font-family: 宋体; line-height: 40px;">房屋建筑工程与市政基础设施工程、铁路工程、公路工程、港口与航道工程、电力工程、水利工程、通信工程等各类工程建设领域，特别要重点治理复杂地质条件下各类隧道工程项目。<span
								lang="EN-US" style="font-size: 16pt; line-height: 40px;">
								<o:p></o:p>
							</span></span></p>
					<p class="MsoNormal"
						style="margin: 0cm 0cm 12pt; line-height: 40px; text-indent: 32pt; font-size: 16pt;"><span
							style="font-size: 16pt; font-family: 宋体; line-height: 40px;">（二）专项治理重点内容。<span lang="EN-US"
								style="font-size: 16pt; line-height: 40px;">
								<o:p></o:p>
							</span></span></p>
					<p class="MsoNormal"
						style="margin: 0cm 0cm 12pt; line-height: 40px; text-indent: 32pt; font-size: 16pt;"><span
							style="font-size: 16pt; font-family: 宋体; line-height: 40px;">重点治理施工现场以下<span lang="EN-US"
								style="font-size: 16pt; line-height: 40px;">8</span>个方面的违法违规行为和事故隐患：<span lang="EN-US"
								style="font-size: 16pt; line-height: 40px;">
								<o:p></o:p>
							</span></span></p>
					<p class="MsoNormal"
						style="margin: 0cm 0cm 12pt; line-height: 40px; text-indent: 32pt; font-size: 16pt;"><span
							lang="EN-US" style="font-size: 16pt; font-family: 宋体; line-height: 40px;">1.</span><span
							style="font-size: 16pt; font-family: 宋体; line-height: 40px;">项目安全组织管理。安全生产责任制和目标建立、定期考核制度及执行、安全技术操作规程建立、安全投入资金保障等情况。<span
								lang="EN-US" style="font-size: 16pt; line-height: 40px;">
								<o:p></o:p>
							</span></span></p>
					<p class="MsoNormal"
						style="margin: 0cm 0cm 12pt; line-height: 40px; text-indent: 32pt; font-size: 16pt;"><span
							lang="EN-US" style="font-size: 16pt; font-family: 宋体; line-height: 40px;">2.</span><span
							style="font-size: 16pt; font-family: 宋体; line-height: 40px;">安全教育培训。教育培训制度建立、作业人员三级安全教育培训和考核、施工管理人员年度安全教育培训等情况。<span
								lang="EN-US" style="font-size: 16pt; line-height: 40px;">
								<o:p></o:p>
							</span></span></p>
					<p class="MsoNormal"
						style="margin: 0cm 0cm 12pt; line-height: 40px; text-indent: 32pt; font-size: 16pt;"><span
							lang="EN-US" style="font-size: 16pt; font-family: 宋体; line-height: 40px;">3.</span><span
							style="font-size: 16pt; font-family: 宋体; line-height: 40px;">专项施工方案。施工组织设计中的安全技术措施、危险性较大的工程专项施工方案编制、方案审核论证审批等情况。<span
								lang="EN-US" style="font-size: 16pt; line-height: 40px;">
								<o:p></o:p>
							</span></span></p>
					<p class="MsoNormal"
						style="margin: 0cm 0cm 12pt; line-height: 40px; text-indent: 32pt; font-size: 16pt;"><span
							lang="EN-US" style="font-size: 16pt; font-family: 宋体; line-height: 40px;">4.</span><span
							style="font-size: 16pt; font-family: 宋体; line-height: 40px;">安全技术交底。施工负责人对相关管理人员及施工作业人员书面安全技术交底、交底内容针对性及操作性等情况。<span
								lang="EN-US" style="font-size: 16pt; line-height: 40px;">
								<o:p></o:p>
							</span></span></p>
					<p class="MsoNormal"
						style="margin: 0cm 0cm 12pt; line-height: 40px; text-indent: 32pt; font-size: 16pt;"><span
							lang="EN-US" style="font-size: 16pt; font-family: 宋体; line-height: 40px;">5.</span><span
							style="font-size: 16pt; font-family: 宋体; line-height: 40px;">隐患排查治理。施工现场安全检查制度及执行、事故隐患整改“五落实”及闭环管理等情况。<span
								lang="EN-US" style="font-size: 16pt; line-height: 40px;">
								<o:p></o:p>
							</span></span></p>
					<p class="MsoNormal"
						style="margin: 0cm 0cm 12pt; line-height: 40px; text-indent: 32pt; font-size: 16pt;"><span
							lang="EN-US" style="font-size: 16pt; font-family: 宋体; line-height: 40px;">6.</span><span
							style="font-size: 16pt; font-family: 宋体; line-height: 40px;">现场安全管理。对分包单位带班管理、设备设施安全管理、洞口及临边防护、人员持证上岗等情况。<span
								lang="EN-US" style="font-size: 16pt; line-height: 40px;">
								<o:p></o:p>
							</span></span></p>
					<p class="MsoNormal"
						style="margin: 0cm 0cm 12pt; line-height: 40px; text-indent: 32pt; font-size: 16pt;"><span
							lang="EN-US" style="font-size: 16pt; font-family: 宋体; line-height: 40px;">7.</span><span
							style="font-size: 16pt; font-family: 宋体; line-height: 40px;">应急管理。应急预案制定、应急救援组织及人员、应急救援器材和设备、定期应急演练等情况。<span
								lang="EN-US" style="font-size: 16pt; line-height: 40px;">
								<o:p></o:p>
							</span></span></p>
					<p class="MsoNormal"
						style="margin: 0cm 0cm 12pt; line-height: 40px; text-indent: 32pt; font-size: 16pt;"><span
							lang="EN-US" style="font-size: 16pt; font-family: 宋体; line-height: 40px;">8.</span><span
							style="font-size: 16pt; font-family: 宋体; line-height: 40px;">复杂地质条件下隧道施工安全风险识别和管控。地质风险因素识别及控制方案、安全风险评估、超前地质预报、瓦斯隧道通风及检测、隧道支护及安全步距、高风险工点实时监测及预警、逃生通道设置等情况。<span
								lang="EN-US" style="font-size: 16pt; line-height: 40px;">
								<o:p></o:p>
							</span></span></p>
					<p class="MsoNormal"
						style="margin: 0cm 0cm 12pt; line-height: 40px; text-indent: 32pt; font-size: 16pt;"><span
							style="font-size: 16pt; font-family: 宋体; line-height: 40px;">三、工作安排<span lang="EN-US"
								style="font-size: 16pt; line-height: 40px;">
								<o:p></o:p>
							</span></span></p>
					<p class="MsoNormal"
						style="margin: 0cm 0cm 12pt; line-height: 40px; text-indent: 32pt; font-size: 16pt;"><span
							style="font-size: 16pt; font-family: 宋体; line-height: 40px;">专项治理行动时间为<span lang="EN-US"
								style="font-size: 16pt; line-height: 40px;">2018</span>年<span lang="EN-US"
								style="font-size: 16pt; line-height: 40px;">4</span>月下旬至<span lang="EN-US"
								style="font-size: 16pt; line-height: 40px;">12</span>月底，具体分为三个阶段。<span lang="EN-US"
								style="font-size: 16pt; line-height: 40px;">
								<o:p></o:p>
							</span></span></p>
					<p class="MsoNormal"
						style="margin: 0cm 0cm 12pt; line-height: 40px; text-indent: 32pt; font-size: 16pt;"><span
							style="font-size: 16pt; font-family: 宋体; line-height: 40px;">（一）动员部署阶段（<span lang="EN-US"
								style="font-size: 16pt; line-height: 40px;">5</span>月<span lang="EN-US"
								style="font-size: 16pt; line-height: 40px;">20</span>日前）。各地区、各有关部门及各有关中央企业要结合已有工作部署和行业（企业）实际情况，制定切实可行的专项治理行动实施方案，进一步明确细化专项治理范围、重点、步骤、措施和要求，做好前期准备和动员部署。<span
								lang="EN-US" style="font-size: 16pt; line-height: 40px;">
								<o:p></o:p>
							</span></span></p>
					<p class="MsoNormal"
						style="margin: 0cm 0cm 12pt; line-height: 40px; text-indent: 32pt; font-size: 16pt;"><span
							style="font-size: 16pt; font-family: 宋体; line-height: 40px;">（二）重点治理阶段（<span lang="EN-US"
								style="font-size: 16pt; line-height: 40px;">5</span>月<span lang="EN-US"
								style="font-size: 16pt; line-height: 40px;">21</span>日<span lang="EN-US"
								style="font-size: 16pt; line-height: 40px;">-11</span>月<span lang="EN-US"
								style="font-size: 16pt; line-height: 40px;">30</span>日）。各地区、各有关部门及各有关单位要组织专门力量，根据实施方案和统一部署，集中开展专项治理，严查违法违规行为和事故隐患。<span
								lang="EN-US" style="font-size: 16pt; line-height: 40px;">
								<o:p></o:p>
							</span></span></p>
					<p class="MsoNormal"
						style="margin: 0cm 0cm 12pt; line-height: 40px; text-indent: 32pt; font-size: 16pt;"><span
							style="font-size: 16pt; font-family: 宋体; line-height: 40px;">（三）总结完善阶段（<span lang="EN-US"
								style="font-size: 16pt; line-height: 40px;">12</span>月<span lang="EN-US"
								style="font-size: 16pt; line-height: 40px;">1</span>日<span lang="EN-US"
								style="font-size: 16pt; line-height: 40px;">-12</span>月<span lang="EN-US"
								style="font-size: 16pt; line-height: 40px;">31</span>日）。各地区、各有关部门及各有关单位要全面梳理专项治理工作情况，系统总结经验做法，建立健全长效机制。<span
								lang="EN-US" style="font-size: 16pt; line-height: 40px;">
								<o:p></o:p>
							</span></span></p>
					<p class="MsoNormal"
						style="margin: 0cm 0cm 12pt; line-height: 40px; text-indent: 32pt; font-size: 16pt;"><span
							style="font-size: 16pt; font-family: 宋体; line-height: 40px;">四、工作措施<span lang="EN-US"
								style="font-size: 16pt; line-height: 40px;">
								<o:p></o:p>
							</span></span></p>
					<p class="MsoNormal"
						style="margin: 0cm 0cm 12pt; line-height: 40px; text-indent: 32pt; font-size: 16pt;"><span
							style="font-size: 16pt; font-family: 宋体; line-height: 40px;">（一）监督检查与严格执法相结合。各地区、各有关部门要结合地方及相关专业工程事故发生规律，按照分级分类原则，结合专项治理工作方案，细化监督检查计划和施工现场检查内容。对重点工程项目在重点治理阶段内要实现检查“全覆盖”，不断扩大抽查涵盖的工程项目范围，发挥抽查对各规模类型工程项目的执法震慑作用。对在监督检查中发现的违法违规行为，按照《安全生产法》《建筑法》等法律法规采取现场处理、责令整改、行政处罚、行政强制等执法措施，切实做到“检查必执法、执法必严格”，促进工程建设各方参建主体依法落实安全生产主体责任。<span
								lang="EN-US" style="font-size: 16pt; line-height: 40px;">
								<o:p></o:p>
							</span></span></p>
					<p class="MsoNormal"
						style="margin: 0cm 0cm 12pt; line-height: 40px; text-indent: 32pt; font-size: 16pt;"><span
							style="font-size: 16pt; font-family: 宋体; line-height: 40px;">（二）严肃查处各类事故。对专项治理期间发生的各类事故，各地区要严格按照《生产安全事故报告和调查处理条例》（国务院令第<span
								lang="EN-US"
								style="font-size: 16pt; line-height: 40px;">493</span>号）的规定，认真组织调查处理，查清事故原因，总结事故教训，对因专项治理工作不力、走过场发生事故的，要依法严肃责任追究。特别是要严格落实《建筑法》《建设工程安全生产管理条例》等法律法规对事故责任企业和人员资质资格的处罚规定，依法采取责令企业停业整顿、降低资质等级或吊销资质证书、责令注册执业人员停止执业或吊销执业资格证书等处罚措施。<span
								lang="EN-US" style="font-size: 16pt; line-height: 40px;">
								<o:p></o:p>
							</span></span></p>
					<p class="MsoNormal"
						style="margin: 0cm 0cm 12pt; line-height: 40px; text-indent: 32pt; font-size: 16pt;"><span
							style="font-size: 16pt; font-family: 宋体; line-height: 40px;">（三）实施信用联合惩戒。各地区要按照安全生产领域失信行为联合惩戒实施办法的要求，对在专项治理行动中发现工程项目存有重大事故隐患，不及时整改，仍组织从业人员冒险作业的；发生较大及以上生产安全责任事故，或<span
								lang="EN-US" style="font-size: 16pt; line-height: 40px;">1</span>年内累计发生<span
								lang="EN-US"
								style="font-size: 16pt; line-height: 40px;">3</span>起及以上造成人员死亡的一般生产安全责任事故的；瞒报、谎报、迟报生产安全事故等失信行为的，严格按规定将负有责任的建设、施工、监理等单位和有关人员纳入联合惩戒对象，实施有效惩戒。<span
								lang="EN-US" style="font-size: 16pt; line-height: 40px;">
								<o:p></o:p>
							</span></span></p>
					<p class="MsoNormal"
						style="margin: 0cm 0cm 12pt; line-height: 40px; text-indent: 32pt; font-size: 16pt;"><span
							style="font-size: 16pt; font-family: 宋体; line-height: 40px;">（四）强化安全教育培训。在专项治理行动中，各企业要进一步完善员工安全教育培训体系，着力提高全员培训、技能培训、重点岗位培训质量和水平。加强对一线作业人员的培训、考核和监督管理，严把相关特种作业人员持证上岗关。一线员工未经培训或培训考核不合格的，不得上岗作业。各地区、各有关部门要加强对企业的督促和指导，推进企业提高安全教育培训质量。<span
								lang="EN-US" style="font-size: 16pt; line-height: 40px;">
								<o:p></o:p>
							</span></span></p>
					<p class="MsoNormal"
						style="margin: 0cm 0cm 12pt; line-height: 40px; text-indent: 32pt; font-size: 16pt;"><span
							style="font-size: 16pt; font-family: 宋体; line-height: 40px;">五、有关要求<span lang="EN-US"
								style="font-size: 16pt; line-height: 40px;">
								<o:p></o:p>
							</span></span></p>
					<p class="MsoNormal"
						style="margin: 0cm 0cm 12pt; line-height: 40px; text-indent: 32pt; font-size: 16pt;"><span
							style="font-size: 16pt; font-family: 宋体; line-height: 40px;">（一）加强组织领导。各地区要充分认识专项治理行动的重要性，成立专项治理工作领导小组，明确职责分工，及时研究解决专项治理中的重点和难点问题。各省级安委会及其办公室要加强指导协调和监督检查，加强与有关行业主管部门的联动，及时掌握情况，推动工作，做好督促落实等有关工作。<span
								lang="EN-US" style="font-size: 16pt; line-height: 40px;">
								<o:p></o:p>
							</span></span></p>
					<p class="MsoNormal"
						style="margin: 0cm 0cm 12pt; line-height: 40px; text-indent: 32pt; font-size: 16pt;"><span
							style="font-size: 16pt; font-family: 宋体; line-height: 40px;">（二）强化过程督导。各省（区、市）要至少开展两次、各地（市）要每季度开展一次建筑施工安全专项治理行动督查检查。国务院安委会办公室将组织有关部门组成督查组，适时对各地区专项治理行动情况进行监督检查。<span
								lang="EN-US" style="font-size: 16pt; line-height: 40px;">
								<o:p></o:p>
							</span></span></p>
					<p class="MsoNormal"
						style="margin: 0cm 0cm 12pt; line-height: 40px; text-indent: 32pt; font-size: 16pt;"><span
							style="font-size: 16pt; font-family: 宋体; line-height: 40px;">（三）及时总结分析。各地区、各有关部门及各有关单位要注重工作的阶段性分析总结，宣传推广好的经验和做法，曝光通报专项治理工作开展不力的单位，推动专项治理工作扎实开展。请于<span
								lang="EN-US" style="font-size: 16pt; line-height: 40px;">5</span>月<span lang="EN-US"
								style="font-size: 16pt; line-height: 40px;">25</span>日前将专项治理实施方案和动员部署情况、<span
								lang="EN-US" style="font-size: 16pt; line-height: 40px;">12</span>月<span lang="EN-US"
								style="font-size: 16pt; line-height: 40px;">31</span>日前将总结报告，报送国务院安委会办公室。<span
								lang="EN-US" style="font-size: 16pt; line-height: 40px;">
								<o:p></o:p>
							</span></span></p>
					<p class="MsoNormal"
						style="margin: 0cm 0cm 12pt; line-height: 40px; text-indent: 32pt; font-size: 16pt;"><span
							style="font-size: 16pt; font-family: 宋体; line-height: 40px;">联系人及电话：周晓明，<span lang="EN-US"
								style="font-size: 16pt; line-height: 40px;">010-64463419</span>、<span lang="EN-US"
								style="font-size: 16pt; line-height: 40px;">64463494</span>（传真）。<span lang="EN-US"
								style="font-size: 16pt; line-height: 40px;">
								<o:p></o:p>
							</span></span></p>
					<p class="MsoNormal"
						style="margin: 0cm 0cm 12pt; line-height: 40px; text-indent: 32pt; font-size: 16pt;"><span
							lang="EN-US" style="font-size: 16pt; font-family: 宋体; line-height: 40px;">
							<o:p>&nbsp;</o:p>
						</span></p>
					<p align="right" class="MsoNormal"
						style="text-align: right; margin: 0cm 0cm 12pt; line-height: 40px; text-indent: 32pt; font-size: 16pt;">
						<span style="font-size: 16pt; font-family: 宋体; line-height: 40px;">国务院安委会办公室<span lang="EN-US"
								style="font-size: 16pt; line-height: 40px;">
								<o:p></o:p>
							</span></span></p>
					<p align="right" class="MsoNormal"
						style="text-align: right; margin: 0cm 0cm 12pt; line-height: 40px; text-indent: 32pt; font-size: 16pt;">
						<span lang="EN-US" style="font-size: 16pt; font-family: 宋体; line-height: 40px;">2018</span><span
							style="font-size: 16pt; font-family: 宋体; line-height: 40px;">年<span lang="EN-US"
								style="font-size: 16pt; line-height: 40px;">4</span>月<span lang="EN-US"
								style="font-size: 16pt; line-height: 40px;">23</span>日<span lang="EN-US"
								style="font-size: 16pt; line-height: 40px;">
								<o:p></o:p>
							</span></span></p>
					<p class="MsoNormal"
						style="margin: 0cm 0cm 12pt; line-height: 40px; text-indent: 32pt; font-size: 16pt;">&nbsp;</p>
				</span>
			</div>
		</div>
	</div>
</template>

<script>
// 引入路由实例
export default {
	name: 'Hteml',
	components: {
	},
	data() {
		return {
		}
	},
	computed: {

	},
	mounted() {

	},
	methods: {

	},
	beforeDestroy() {

	}
}
</script>
<style scoped></style>